export const deleteAccountConstants = {
  DELETE_ACCOUNT_LOADING: "DELETE_ACCOUNT_LOADING",
  DELETE_ACCOUNT_ERROR: "DELETE_ACCOUNT_ERROR",
  DELETE_ACCOUNT_SUCCESS: "DELETE_ACCOUNT_SUCCESS",
};
